import { markRaw } from 'vue'
import SubscriptionCoverView from './SubscriptionCoverView.vue'
import schema from './schema'
import uiSchema from './ui-schema'
import {
  DEFAULT_COLOR_PRIMARY,
  DEFAULT_COLOR_PRIMARY_HOVER,
  DEFAULT_COLOR_WHITE,
} from '~/components/page-editor/constants'

export default {
  viewComponent: markRaw(SubscriptionCoverView),
  editorSchema: schema,
  editorUISchema: uiSchema,
  editorData: {
    text: '# Upgrade your access\n\nGet the subscription plan that unlocks premium features and content.',
    textColor: DEFAULT_COLOR_WHITE,
    textAlign: 'center',
    paddingSize: 'md',
    isBgImage: true,
    bgColor: '#000000',
    bgImage: 'https://cdn.wnhub.io/39253/65dde526e1a6c4.93735968.jpg',
    subscriptionButton: {
      type: 'button',
      look: 'solid',
      color: DEFAULT_COLOR_PRIMARY,
      colorHover: DEFAULT_COLOR_PRIMARY_HOVER,
      textColor: DEFAULT_COLOR_WHITE,
      text: 'Subscribe',
    },
    additionalButtonsPosition: 'right',
    additionalButtons: [],
    maxWidth: 576, // max-w-xl
  },
}
